import { useEffect } from "react"
import { Link } from "react-router-dom"

import { useOnSuccessFullPayment } from "modules/Booking/common/hooks"
import { Spinner } from "components/Spinner"
import { BrowserWarningBanner, BrowserWarningType } from "components/BrowserWarningBanner"
import { Analytics } from "utils/analytics"
import { ReferralLinkWidget } from "modules/ClientAccount/components"
import { GiftCertificateBanner } from "modules/BookingCommon/components"
import { TelegramBlock } from "components"
import { UserInfoPageHash } from "modules/ClientAccount"
import { isGetBookingDetailsResponse } from "modules/BookingCommon/common/utils"
import { SESSION_TYPE } from "modules/Booking/common/constants"
import { createdBookingLoader, paidBookingLoader } from "modules/BookingCommon/common/queries"
import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"
import { SessionDetails, SessionInfoCard } from "modules/Booking/AfterPaymentPage/components"
import { SESSION_LENGTH } from "utils/env-management"
import { useBannerSettings } from "utils/Banners/useBannerSettings"

export function DefaultSession() {
    const bookingHash = createdBookingLoader.getHash()
    const paidBookingQuery = paidBookingLoader.useGet(bookingHash)
    const paidBookingDetails = paidBookingQuery.data
    const bookingQuery = createdBookingLoader.useGet(bookingHash)
    const bookingDetails = bookingQuery.data
    const isFetched = bookingQuery.isFetched && paidBookingQuery.isFetched
    const isError = bookingQuery.isError || paidBookingQuery.isError
    const onSuccessfulPayment = useOnSuccessFullPayment()
    const { isShowTelegramBanner } = useBannerSettings()
    const [{ userAccount }] = useClientContext()

    useEffect(() => {
        if (isGetBookingDetailsResponse(paidBookingDetails)) {
            if (paidBookingDetails.is_free) {
                Analytics.after_successful_booking_free({
                    booking_id: paidBookingDetails.booking_id,
                    psy: paidBookingDetails.psy,
                })
            } else {
                Analytics.after_successful_booking({
                    booking_id: paidBookingDetails?.booking_id,
                    psy: paidBookingDetails.psy,
                })
            }
            Analytics.booking_details({
                name: paidBookingDetails.client_name,
                email: paidBookingDetails.client_email,
                orderId: paidBookingDetails.booking_id,
                price: paidBookingDetails.price,
            })
        }
    }, [isFetched])

    useEffect(() => {
        if (isFetched && !isError) {
            onSuccessfulPayment()
        }
    }, [isFetched, isError])

    return (
        <div className="redesign-container">
            {isFetched && isGetBookingDetailsResponse(paidBookingDetails) ? (
                <div className="after-payment">
                    {isError ? (
                        <div>
                            Ошибка. Перезагрузите страницу, а&nbsp;если не&nbsp;помогло,
                            то&nbsp;обратитесь в&nbsp;службу поддержки
                        </div>
                    ) : (
                        <>
                            <div className="after-payment__left">
                                <SessionDetails
                                    sessionType={SESSION_TYPE.DEFAULT}
                                    phone={paidBookingDetails.client_phone}
                                    email={paidBookingDetails.client_email}
                                />
                                {paidBookingDetails.psy.experiment_group &&
                                    paidBookingDetails.is_online && (
                                        <BrowserWarningBanner
                                            type={BrowserWarningType.Session}
                                            className="after-payment__browser-waring"
                                        />
                                    )}
                                {isShowTelegramBanner && !userAccount.telegram_account && (
                                    <TelegramBlock
                                        button={
                                            <Link
                                                className="button-primary is-inline-block telegramButton w-100 text-center"
                                                to={`/my/userinfo#${UserInfoPageHash.TELEGRAM_ACCOUNT}`}
                                            >
                                                Подключить
                                            </Link>
                                        }
                                    />
                                )}
                                <SessionInfoCard
                                    sessionType={SESSION_TYPE.DEFAULT}
                                    psy={paidBookingDetails.psy}
                                    serviceType={paidBookingDetails.service_type}
                                    isOnline={paidBookingDetails.is_online}
                                    psyPhone={paidBookingDetails.psy_phone}
                                    psyFullName={paidBookingDetails.psy_full_name}
                                    price={paidBookingDetails.price}
                                    priceUsd={paidBookingDetails.price_usd}
                                    paymentSystem={paidBookingDetails.payment_system}
                                    rfc3339_start_datetime={
                                        paidBookingDetails.rfc3339_start_datetime
                                    }
                                    durationMinutes={
                                        bookingDetails?.duration_minutes ||
                                        SESSION_LENGTH.toString()
                                    }
                                    callEnabled={paidBookingDetails.psy.experiment_group}
                                    lobbyLink={`/my/call/lobby/${bookingHash}`}
                                />
                                <ReferralLinkWidget
                                    className="after-payment__last-widget"
                                    source="payment-succeed"
                                />
                            </div>
                            <div className="after-payment__banners">
                                <GiftCertificateBanner />
                            </div>
                        </>
                    )}
                </div>
            ) : (
                <Spinner />
            )}
        </div>
    )
}
